import "core-js/stable";
import "regenerator-runtime/runtime";
import ReactDOM from "react-dom";
import React from "react";
import * as Sentry from "@sentry/react";
import { Provider } from "react-redux";
import { Router } from "react-router-dom";
import { applyMiddleware, compose, createStore } from "redux";
import history from "./js/middlewares/history";
import { routerMiddleware } from "react-router-redux";
import Routes from "./js/routes/Routes";
import clientMiddleware from "./js/middlewares/client";
import localStorageLoad from "./js/middlewares/localStorageLoad";
import localStorageDump from "./js/middlewares/localStorageDump";
import ApiClient from "./js/helpers/ApiClient";
import reducer from "./js/reducers";
import C from "./js/constants";
import { configureBaseUrl } from "./js/api/axiosConfig";
import config from "./js/config/config";
import { ThemeProvider } from "@mui/material";
import { globalDkMUITheme } from "./js/globalMUITheme";

const environment =
  (config.environment && config.environment.toLowerCase()) || "local";

const sentryEnabled =
  environment == "production" ||
  environment == "staging" ||
  environment == "development" ||
  config.DK_SENTRY_ENABLED_LOCAL
    ? true
    : false;

if (environment === "local") {
  console.log("Sentry enabled: ", sentryEnabled);
}

if (sentryEnabled) {
  Sentry.init({
    dsn: "https://d32f001bf60a34c51c0b7b495842070b@o4504011967496192.ingest.sentry.io/4506119069827072",
    debug: environment === "local",
    environment: environment,
  });
}

const logger = (store) => (next) => (action) => {
  if (action.type && environment === "local") {
    console.log("dispatching", action.type, action);
  }
  let result = next(action);
  if (action.type && environment === "local") {
    console.log("next state", store.getState());
  }
  return result;
};

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

configureBaseUrl();
const apiClient = new ApiClient();
const enhancer = composeEnhancers(
  applyMiddleware(
    localStorageLoad,
    clientMiddleware(apiClient),
    localStorageDump,
    routerMiddleware(history),
    logger
  )
);
const store = createStore(reducer, undefined, enhancer);

store.dispatch({ type: C.INIT_STORE });
window.store = store;

ReactDOM.render(
  <ThemeProvider theme={globalDkMUITheme}>
    <Provider store={store}>
      <Router history={history}>
        <Routes />
      </Router>
    </Provider>
  </ThemeProvider>,
  document.getElementById("react-root")
);
